export enum States {
	AL = 'AL',
	AK = 'AK',
	AS = 'AS',
	AZ = 'AZ',
	AR = 'AR',
	CA = 'CA',
	CNMI = 'CNMI',
	CO = 'CO',
	CT = 'CT',
	DE = 'DE',
	DC = 'DC',
	FL = 'FL',
	GA = 'GA',
	GU = 'GU',
	HI = 'HI',
	ID = 'ID',
	IL = 'IL',
	IN = 'IN',
	IA = 'IA',
	KS = 'KS',
	KY = 'KY',
	LA = 'LA',
	ME = 'ME',
	MD = 'MD',
	MA = 'MA',
	MI = 'MI',
	MN = 'MN',
	MS = 'MS',
	MO = 'MO',
	MT = 'MT',
	NE = 'NE',
	NV = 'NV',
	NH = 'NH',
	NJ = 'NJ',
	NM = 'NM',
	NC = 'NC',
	NY = 'NY',
	ND = 'ND',
	OH = 'OH',
	OK = 'OK',
	OR = 'OR',
	PA = 'PA',
	PR = 'PR',
	RI = 'RI',
	SC = 'SC',
	SD = 'SD',
	TN = 'TN',
	TX = 'TX',
	UT = 'UT',
	VI = 'VI',
	VT = 'VT',
	VA = 'VA',
	WA = 'WA',
	WV = 'WV',
	WI = 'WI',
	WY = 'WY',
}
